import Vue from 'vue'
import Router from 'vue-router'
// import App from '../App'
const index = () => import('../page/index')
const products = () => import('../page/products')
const downloads = () => import('../page/downloads')
const cooperation = () => import('../page/cooperation')
const aboutUs = () => import('../page/aboutUs')
const newItem = () => import('../page/newItem')
const newList = () => import('../page/newList')
const developmentHistory = () => import('../page/developmentHistory')
const contactOurs = () => import('../page/contactOurs')
const tutorial = () => import('../page/tutorial')

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '',
      redirect: '/index'
    }, {
      path: '/index',
      component: index,
      name: 'index'
    }, {
      path: '/produts',
      component: products,
      name: 'produts'
    }, {
      path: '/downloads',
      component: downloads,
      name: 'downloads'
    }, {
      path: '/cooperation',
      component: cooperation,
      name: 'cooperation'
    }, {
      path: '/aboutUs',
      component: aboutUs,
      name: 'aboutUs'
    }, {
      path: '/newitem',
      component: newItem,
      name: 'newItem'
    }, {
      path: '/newlist',
      component: newList,
      name: 'newList'
    }, {
      path: '/developmentHistory',
      component: developmentHistory,
      name: 'developmentHistory'
    }, {
      path: '/contactOurs',
      component: contactOurs,
      name: 'contactOurs'
    }, {
      path: '/tutorial',
      component: tutorial,
      name: 'tutorial'
    },
    {
      path: '*',
      component: index
    }
  ],
  // scrollBehavior: () => ({ y: 0 })
})



// WEBPACK FOOTER //
// ./src/router/index.js